import React from 'react'

export type ConditionalWrapperProps<T> = {
  condition: T
  wrapper: (condition: T, children?: React.ReactNode) => React.ReactNode
}

export default function ConditionalWrapper<T>(props: React.PropsWithChildren<ConditionalWrapperProps<T>>) {
  return <>{props.wrapper(props.condition, props.children)}</>
}
